import script from "./ThankYouView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThankYouView.vue?vue&type=script&setup=true&lang=js"

import "./ThankYouView.vue?vue&type=style&index=0&id=42d627f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42d627f8"]])

export default __exports__